<template>
    <div>

        <b-tabs pills>
            <b-tab @click="handleOnChangeTab(ElectronicLecturesAssign)" title="Bài giảng điện tử đang giao"
                :active="tabActive == ElectronicLecturesAssign">
                
                <TabElectronicLectureAssign  v-if="tabActive == ElectronicLecturesAssign" />
            </b-tab>
            <b-tab @click="handleOnChangeTab(ElectronicLectureWarehouse)" title="Kho bài giảng điện tử"
                :active="tabActive == ElectronicLectureWarehouse">
                <TabElectronicLectureWarehouse v-if="tabActive == ElectronicLectureWarehouse" />
            </b-tab>

        </b-tabs>
    </div>

</template>
<script>
import TabElectronicLectureAssign from './../lesson_component/TabElectronicLectureAssign.vue'
import TabElectronicLectureWarehouse from './../lesson_component/TabElectronicLectureWarehouse'
export default {
    components: {
        TabElectronicLectureWarehouse,
        TabElectronicLectureAssign
    },
    data() {
        return {
            tabActive: 1,
            ElectronicLecturesAssign: 1,
            ElectronicLectureWarehouse: 2
            
        }
    },
    methods: {
        
        handleOnChangeTab(tab){
            this.tabActive = tab
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}
.display-flex-space-between {
    justify-content: space-between;
}
</style>